import React from "react";
import withIconComponent from "../withIconComponent";

var Plus = function Plus() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7v10M17 12H7"
  }));
};

export default withIconComponent("UiPlus", false)(Plus);